import { Locale } from "@/Common/Models/Localization/Locale";
import { DiagnosticCodeType } from "@/Common/Models/Patient/Enum/DiagnosticCodeType";
import { SitesModel } from "@/Common/Models/Sites/SitesModel";
import { CanadaState } from "@/Common/Resources/Lookups/Enums/CommonLookupCodes";

// corresponds to DiagnosticCodes table
class Diagnosis {
    public Active: boolean;

    public Id: string;
    public Type: DiagnosticCodeType;
    public Code: string;

    public Name_EN: string;
    public Name_ES: string;
    public Name_FR: string;

    public Acronym_EN: string;
    public Acronym_ES: string;
    public Acronym_FR: string;

    public constructor(fields?: Partial<Diagnosis>) {
        (Object as any).assign(this, fields);
    }

    /**
     * * Get the translated display name for the current locale.
     * * @param siteLocale The locale to try if the diagnostic code isn't translated into the current one.
     * */
    public getName(siteLocale: Locale = null): string {
        return this.getRawName(sessionStore.locale)
            || this.getRawName(siteLocale)
            || this.getRawName(Locale.en);
    }

    /**
     * Get the translated display name without fallback.
     * @param locale The locale whose field to get.
     */
    private getRawName(locale: Locale): string {
        switch (locale) {
            case Locale.es:
                return this.Name_ES;
            case Locale.fr:
                return this.Name_FR;
            default:
                return this.Name_EN;
        }
    }

    public getLocaleFromSite(siteModel: SitesModel): Locale {
        const selectedLanguage = sessionStore.locale;

        if (siteModel.isMexicoSite() || siteModel.isColombiaSite()) {
            return this.getRawName(sessionStore.locale)
                ? sessionStore.locale
                : Locale.es; // fallback to Spanish in Mexio or Columbia
        }

        else if (siteModel.isSiteInProvince(CanadaState.BritishColumbia)
            && (
                (selectedLanguage === Locale.fr && !this.Name_FR)
                || (selectedLanguage === Locale.es)
            )
        ) {
            return Locale.en;
        }
        else
            return selectedLanguage;
    }
}

export { Diagnosis };
